<div class="wrapper">
  <div class="ring">
    <mat-progress-spinner
      class="ring-spinner"
      diameter="40"
      strokeWidth="3"
      mode="determinate"
      [value]="progressValue"
    ></mat-progress-spinner>
    <span class="ring-value">{{ remainingSeconds }}</span>
  </div>
  <div class="content">
    <div class="title">Update ready</div>
    <div class="message">
      This page will reload automatically to load the latest version. Save your
      work now.
    </div>
  </div>
</div>
